import React, { useEffect, useState } from "react";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";


import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select, Image } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Carousel from 'react-material-ui-carousel';

import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import { VEH_IMAGE_URL } from "../../Api/constants";
import { Modal } from 'antd';
import MyRichTextEditor from "../../Components/RichTextEditor";
const { Option } = Select;

const VehicleDetails = () => {

    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);

    const [vehicle, setVehicle] = useState([]);
    const [reports, setReports] = useState();
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [vehicleNotes, setVehicleNotes] = useState([]);
    const [isAddNote, setIsAddNote] = useState('');
    const [vehicleDocuments, setVehicleDocumens] = useState([]);


    const history = useNavigate();

    const getVehicleDetails = async () => {
        const onSuccess = (res) => {
            console.log('res', res);

            setVehicle(res.data);
            console.log('res.data', res.data);
            setReports(res.reports);
            setVehicleDocumens(res.documents);
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && alert(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            veh_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getVehicleDetails, onSuccess, onError);
    }

    const moveTrash = async () => {
        setConfirmDelete(false);
        const onSuccess = (res) => {
            // console.log('res', res);
            history('/vehicles');
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && message.error(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            veh_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        const api = vehicle?.is_deleted == 1 ? apiRoutes.restoreVehicle : apiRoutes.moveVehicleToTrash;
        await postRequest(body, api, onSuccess, onError);

    }

    const saveNote = async (value) => {

        const onSuccess = (res) => {
            setIsAddNote(false);
            setVehicleNotes(res.vehicle_notes)
            message.success('Note saved!');
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            veh_id: id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addVehicleNotes, onSuccess, onError);
    }

    const getVehicleNotes = async (value) => {

        const onSuccess = (res) => {
            setVehicleNotes(res.data);
            dispatch(setLoader(false));
        }

        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to get notes');
        }
        const body = {
            token: user?.token,
            veh_id: id,
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getVehicleNotes, onSuccess, onError);
    }



    const updateNote = async (value, note_id, cb) => {

        const onSuccess = () => {
            dispatch(setLoader(false));
            message.success('Note saved!');
            cb();
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.updateVehicleNote, onSuccess, onError);


    }

    const deleteNote = async (note_id) => {

        const onSuccess = (res) => {
            dispatch(setLoader(false));
            message.success('Note deleted!');
            setVehicleNotes(res.data)

        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to delete note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            veh_id: id
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.deleteVehicleNote, onSuccess, onError);
    }



    useEffect(() => {
        getVehicleDetails();
        getVehicleNotes();
    }, []);



    const RenderAgreements = React.useCallback(
        () => {
            {
                return vehicleNotes?.map((v, i) => {
                    return (
                        <div style={{ width: "100%", }}>
                            <Typography style={{ color: appColors.black, fontSize: 16, fontFamily: 'Poppins', marginLeft: 10, marginTop: 20 }}>Created at: {new Date(v.created_at).toLocaleString()}</Typography>

                            <MyRichTextEditor
                                disabled={true}
                                val={v.note}
                                data={v}
                                edit={true}
                                del={true}
                                onSave={(value, cb = () => { }) => updateNote(value, v.vn_id, cb)}
                                onDelete={() => deleteNote(v.vn_id)}
                            />
                        </div>
                    )
                })
            }
        },
        [vehicleNotes],
    )

    return (
        <>
            <ThemeProvider theme={theme}>


                <Modal
                    title={`Are you sure you want to ${vehicle?.is_deleted == 1 ? "restore" : "delete"} this vehicle?`}
                    visible={confirmDelete}
                    onCancel={() => setConfirmDelete(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setConfirmDelete(false)}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={moveTrash}>
                            {vehicle?.is_deleted == 1 ? "Restore" : "Delete"}
                        </Button>,
                    ]}
                >
                </Modal>


                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Vehicle Details
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', }}>

                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Total Agreements
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_agreements}
                                    </Typography>
                                </div>
                            </div>
                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Paid / Total Invoices Amounts
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_paid_amount}/{reports?.total_invoice_amount}
                                    </Typography>
                                </div>
                            </div>
                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Total Rented persons
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_rented_persons}
                                    </Typography>
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', width: "100%", borderRadius: 5, flexDirection: 'row', padding: 5, paddingTop: 10, backgroundColor: 'white', marginTop: 20, paddingLeft: 20, flexWrap: 'wrap' }} >
                            <div style={{ width: 220, height: 180, borderRadius: 5, alignItems: 'center', justifyContent: 'center', backgroundColor: appColors.grey }}>
                                {
                                    vehicle?.images?.length &&
                                    <Carousel
                                        indicators={false} // Hide the dots

                                        style={{ height: 180, borderRadius: 10, marginTop: 5 }} >
                                        {vehicle?.images.map((image, index) => (
                                            <Image key={index} src={VEH_IMAGE_URL + image} alt="slider-item" style={{ width: '100%', height: 180, objectFit: 'cover' }} />

                                            // <Item key={index} image={VEH_IMAGE_URL + image} />
                                        ))}
                                    </Carousel>
                                }
                            </div>
                            <div style={{ marginLeft: 15, display: 'flex', flexDirection: 'column', minWidth: "40%", maxWidth: "100%", overflowY: 'auto' }}>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Name</Typography>
                                        <Typography sx={valueText} >{vehicle?.veh_name}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Reg no</Typography>
                                        <Typography sx={valueText} >{vehicle?.reg_no}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Make</Typography>
                                        <Typography sx={valueText} >{vehicle?.make}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Model</Typography>
                                        <Typography sx={valueText} >{vehicle?.model}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Year</Typography>
                                        <Typography sx={valueText} >{vehicle?.year}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Seats</Typography>
                                        <Typography sx={valueText} >{vehicle?.seats}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Transmission</Typography>
                                        <Typography sx={valueText} >{vehicle.transmission}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Body Type</Typography>
                                        <Typography sx={valueText} >{vehicle.body_type}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Color</Typography>
                                        <Typography sx={valueText} >{vehicle.color}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Fuel Type</Typography>
                                        <Typography sx={valueText} >{vehicle.fuel_type}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Mileage</Typography>
                                        <Typography sx={valueText} >{vehicle.milage}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Rent</Typography>
                                        <Typography sx={valueText} >{vehicle.rent}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >License Exp Date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.license_exp_date).toLocaleDateString()}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Tax exp date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.tax_exp_date).toLocaleDateString()}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >MOT test date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.mot_test_date).toLocaleDateString()}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >MOT exp date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.mot_exp_date).toLocaleDateString()}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >PCO test date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.pco_test_date).toLocaleDateString()}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >PCO exp date</Typography>
                                        <Typography sx={valueText} >{new Date(vehicle.pco_exp_date).toLocaleDateString()}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={{ width: "100%", display: 'flex', flexDirection: 'row' }}>
                                        <Typography sx={{ ...fieldText }} >Rental Details</Typography>
                                        <Typography sx={{ ...valueText, marginLeft: 2 }} >{vehicle.rental_details}</Typography>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 15 }}>

                                {
                                    vehicle?.is_deleted == 1 ? null :

                                        <div
                                            onClick={() => history(`/edit-vehicle/${id}`)}
                                            style={{ width: 50, height: 29, borderStyle: 'solid', borderRadius: 20, display: 'flex', borderWidth: 1, borderColor: appColors.primary, alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                            <Typography sx={{ fontSize: 12, color: appColors.primary, fontFamily: 'Poppins', fontWeight: 600 }} >Edit</Typography>
                                        </div>

                                }
                                <div
                                    onClick={() => setConfirmDelete(true)}
                                    style={{ width: 120, height: 29, borderStyle: 'solid', borderRadius: 20, display: 'flex', borderWidth: 1, borderColor: appColors.red, alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginTop: 10, backgroundColor: appColors.red }}>
                                    <Typography sx={{ fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600 }} >{vehicle?.is_deleted == 1 ? "Restore" : "Move to trash"}</Typography>
                                </div>
                                <div
                                    onClick={() => history('/rental-history/' + id)}
                                    style={{ width: 120, height: 29, borderRadius: 20, display: 'flex', borderColor: appColors.primary, alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginTop: 10, backgroundColor: appColors.primary }}>
                                    <Typography sx={{ fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600 }} >{"Rental history"} </Typography>
                                </div>
                            </div>
                        </div>


                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Notes</Typography>
                                <div
                                    onClick={() => setIsAddNote(!isAddNote)}
                                    style={{ cursor: 'pointer', height: 20, alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: 5, borderRadius: 50, marginRight: 10 }}>
                                    {
                                        isAddNote ?
                                            <RemoveIcon />
                                            :
                                            <AddIcon style={{ color: appColors.primary, fontSize: 24 }} />
                                    }
                                </div>
                            </div>
                            {
                                isAddNote &&
                                <div style={{ borderWidth: 1, borderStyle: 'solid', width: "99%", marginTop: 10, display: 'flex', alignSelf: 'center', flexDirection: 'column', borderColor: appColors.greyText }}>
                                    <div style={{ display: 'flex', marginTop: 10, marginBottom: 5, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                        Add new note
                                    </div>
                                    <MyRichTextEditor
                                        submitButtonText="Add note"
                                        onSave={(value) => saveNote(value)}
                                    />
                                </div>
                            }
                            {
                                !vehicleNotes?.length &&
                                <div style={{ display: 'flex', marginTop: 20, marginBottom: 10, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                    You have no notes for this vehicle
                                </div>
                            }
                            <RenderAgreements />
                        </div>
                        {/* NEW: Vehicle Documents Section */}
                <div style={{ marginTop: 30, width: "100%" }}>
                    <Typography style={{ fontSize: 18, fontWeight: 600, color: appColors.primary, marginBottom: 15 }}>
                        Vehicle Documents
                    </Typography>

                    {vehicleDocuments && vehicleDocuments.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {vehicleDocuments.map((doc) => (
                                <div
                                    key={doc.doc_id}
                                    style={{
                                        padding: 16,
                                        backgroundColor: '#f9f9f9',
                                        borderRadius: 10,
                                        border: '1px solid #e0e0e0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
                                    onClick={() => window.open(doc.full_url, '_blank')} // Direct open in new tab
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        {/* Icon based on type */}
                                        {doc.file_path.endsWith('.pdf') ? (
                                            <span style={{ fontSize: 28 }}>📄</span>
                                        ) : (
                                            <span style={{ fontSize: 28 }}>🖼️</span>
                                        )}

                                        <div>
                                            <Typography style={{ fontWeight: 600, color: appColors.black }}>
                                                {doc.file_name}
                                            </Typography>
                                            <Typography style={{ fontSize: 12, color: '#888' }}>
                                                {doc.doc_type.replace(/_/g, ' ').toUpperCase()} •
                                                Uploaded: {new Date(doc.uploaded_at).toLocaleDateString()}
                                            </Typography>
                                        </div>
                                    </div>

                                    <Button
                                        type="link"
                                        style={{ color: appColors.primary }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(doc.full_url, '_blank');
                                        }}
                                    >
                                        Open →
                                    </Button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ padding: 20, textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                            No documents uploaded for this vehicle yet.
                        </div>
                    )}
                </div>

                    </div>
                </div>
            </ThemeProvider>
        </>
    )

}

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20,
    marginTop: 10
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', height: 'auto',
    marginTop: 5, paddingBottom: 3, fleexWrap: 'wrap'

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}

export default VehicleDetails
